import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Application } from '../../../models/application.model';
import { ApplicationService } from './../../../services/application/applications.service';

@Component({
  selector: 'app-application-form',
  templateUrl: 'applicationForm.component.html',
  styles: ['label.required:after {top: 0}']
})

export class ApplicationFormComponent implements OnInit {
  @Output() applicationAdded: EventEmitter<any> = new EventEmitter<any>();
  @Output() applicationUpdated: EventEmitter<any> = new EventEmitter<any>();
  @Input() dialogBoxItem: Application;
  addEditForm: FormGroup;

  fields: any;
  public invalidSubmit: boolean;

  constructor(
    private fb: FormBuilder,
    private appService: ApplicationService ) {
  }

  ngOnInit() {

    this.appService.getFields().subscribe(res => {
      this.fields = res;
    });

    this.addEditForm = this.fb.group({
      'name': new FormControl(this.dialogBoxItem.name),
      'descr': new FormControl(this.dialogBoxItem.descr),
      'order_index': new FormControl(this.dialogBoxItem.order_index),
    });

  }

  saveOrUpdate(dialogBox: any): void {

    if (!this.addEditForm.valid) {
      this.invalidSubmit = true;
      return;
    }
    this.invalidSubmit = false;

    let newData = Object.assign({}, this.dialogBoxItem, this.addEditForm.value);
    if (newData.id == null) {
      this.applicationAdded.emit(newData);
    } else {
      this.applicationUpdated.emit(newData);
    }
  }

}




// WEBPACK FOOTER //
// ./src/app/views/administration/application/applicationForm.component.ts